import { AppRoutes } from "@/routes/config";
import { TUserType, USER_TYPE } from "@/types/enum";

/**
 * Returns allowed route patterns per role.
 * Empty array = allow all (RSO users).
 */
export const getAllowedRoutes = (userType: TUserType): string[] => {
  if (userType === USER_TYPE.RSO_USER) return [];
  if (userType === USER_TYPE.SUPPORT_USER) {
    return [
      AppRoutes.home,
      AppRoutes.examSteps,
      AppRoutes.examStepDetail,
      AppRoutes.learningProgress,
      AppRoutes.learningProgressDetail,
      AppRoutes.learningProgressLearnerDetail,
      AppRoutes.learningProgressLearnerEdit,
      AppRoutes.learnerList,
      AppRoutes.learnerDetail,
      AppRoutes.learnerPlanList,
      AppRoutes.companyDetail,
      AppRoutes.userSettingDetail,
      AppRoutes.userSettingEdit,
      AppRoutes.userSettingChangeEmail,
      AppRoutes.information,
      AppRoutes.informationDetail,
    ];
  }

  if (userType === USER_TYPE.COMPANY_USER) {
    return [
      AppRoutes.home,
      AppRoutes.examSteps,
      AppRoutes.examStepDetail,
      AppRoutes.learningProgress,
      AppRoutes.learningProgressDetail,
      AppRoutes.learningProgressLearnerDetail,
      AppRoutes.learningProgressLearnerEdit,
      AppRoutes.learnerList,
      AppRoutes.learnerCreate,
      AppRoutes.learnerBulkImport,
      AppRoutes.learnerBulkImportComplete,
      AppRoutes.learnerDetail,
      AppRoutes.learnerEdit,
      AppRoutes.learnerPlanList,
      AppRoutes.companyDetail,
      AppRoutes.companyEdit,
      AppRoutes.userSettingDetail,
      AppRoutes.userSettingEdit,
      AppRoutes.userSettingChangeEmail,
      AppRoutes.information,
      AppRoutes.informationDetail,
    ];
  }

  return [];
};

